import styled from "styled-components";

export const ProductsSection = styled.section`
  padding: 4rem 0 5rem;
`;

export const SectionEyebrow = styled.p`
  font-family: "SatoshiRegular", sans-serif;
  font-size: 0.9rem;
  color: #888;
  margin-bottom: 0.5rem;
`;

export const SectionTitle = styled.h2`
  font-family: "SatoshiBold", sans-serif;
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  color: ${(props) => props.theme.colors.balck_200};
  margin-bottom: 2rem;
  font-weight: 700;
`;

export const ProductsPanel = styled.div`
  background: ${(props) => props.theme.colors.white_100};
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
  border: 1px solid #f0f0f0;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
`;

export const ProductPill = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1.1rem;
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 50px;
  font-family: "SatoshiBold", sans-serif;
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.balck_200};
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors.purple_100};
    box-shadow: 0 4px 16px rgba(74, 147, 207, 0.15);
  }
`;

export const PillIcon = styled.span<{ $hue: number }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  background: radial-gradient(
    circle at 30% 30%,
    hsl(${(p) => p.$hue}, 70%, 75%) 0%,
    hsl(${(p) => p.$hue + 40}, 60%, 55%) 100%
  );
`;
